export default "__VITE_ASSET__CZmWDatx__"